import React from 'react';
import {observer} from 'mobx-react';
import {GenericModal} from '@techsee/techsee-ui-common/lib/modals/generic';
import {IVideoController} from './VideoController';
import './RemoveParticipantModal.scss';

interface RemoveParticipantModalProps {
    ctrl: IVideoController;
}

const Header = observer(({ctrl}: RemoveParticipantModalProps) => (
    <div className='remove-participant-header'>
        <h4>{ctrl.translate('REACT.NWAY.REMOVE_PARTICIPANT_TITLE')}</h4>
    </div>
));

const Content = observer(({ctrl}: RemoveParticipantModalProps) => (
    <div className='remove-participant-body'>
        <p>{ctrl.removeConfirmMessage}</p>
    </div>
));

const Footer = observer(({ctrl}: RemoveParticipantModalProps) => (
    <div className='remove-participant-footer'>
        <button className='btn btn-cancel' onClick={ctrl.cancelRemoveParticipant}>
            {ctrl.cancelBtnText}
        </button>
        <button className='btn btn-confirm' onClick={ctrl.confirmRemoveParticipant}>
            {ctrl.confirmBtnText}
        </button>
    </div>
));

@observer
export class RemoveParticipantModal extends React.Component<RemoveParticipantModalProps> {
    render() {
        const {ctrl} = this.props;

        return (
            <GenericModal
                className='remove-participant-modal'
                header={() => <Header ctrl={ctrl} />}
                content={() => <Content ctrl={ctrl} />}
                toolbar={() => <Footer ctrl={ctrl} />}
                onHideHandler={ctrl.cancelRemoveParticipant}
                isCloseVisible={false}
                show={ctrl.showRemoveModal}
            />
        );
    }
}
